import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader } from '../../components/ui/card';
import { ErrorState, LoadingState } from '../../components/ui/state';
import { api } from '../../shared/api';
import { formatDateTime } from '../../shared/format';

export function DaycarePhotosPage() {
  const { daycareId = '' } = useParams();
  const daycareQuery = useQuery({ queryKey: ['daycare', daycareId], queryFn: () => api.daycares.get(daycareId), enabled: Boolean(daycareId) });

  if (daycareQuery.isLoading) return <LoadingState label="Cargando guarderia" />;
  if (daycareQuery.isError) return <ErrorState message={daycareQuery.error.message} />;

  return (
    <div className="max-w-2xl space-y-5">
      <div>
        <h1 className="text-2xl font-semibold text-slate-950">Fotos de guarderia</h1>
        <p className="mt-1 text-sm text-slate-500">Entrada: {daycareQuery.data ? formatDateTime(daycareQuery.data.startAt) : ''}</p>
      </div>
      <Card>
        <CardHeader><h2 className="text-sm font-semibold">Carga de fotos oculta</h2></CardHeader>
        <CardContent>
          <p className="text-sm text-[#596a52]">La subida de fotos esta desactivada para guarderia.</p>
        </CardContent>
      </Card>
    </div>
  );
}
